import Breadcrumb from "components/LM/common/Breadcrumb";
import DetailsForm from "components/LM/Voice/DetailsForm";
import VoiceRelations from 'components/LM/Voice/Relations';
import { useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import Card from "react-bootstrap/Card";
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import { Loader } from '@launchmetrics/lm-ui';
import 'components/LM/Voice/Voice.scss';

function NewVoice() {
    const [loading, setLoading] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const detailFormRef = useRef();

    const onClickCreate = () => {
        setLoading(true);
        detailFormRef.current.onSubmit();
    };

    const showLoader = () => {
        if (loading) {
            return <Loader styleProps={{ marginLeft: '10px'}}size={20} />;
        }
    };

    const onVoiceCreated = id => {
        window.location.href = `/voices/${id}`;
    };

    return (
        <>
            <Container fluid className="p-0 voice">
                <Row>
                    <Col md="6" xl="6" className="voice-header align-text-bottom">
                        <Breadcrumb items={[
                            <>New Voice</>
                        ]} />
                    </Col>
                </Row>
                <Row>
                    <Col md="5" lg="5" xl="3">
                        <Card className="details">
                            <Card.Body>
                                <DetailsForm
                                    ref={detailFormRef}
                                    allowCreateVoice={true}
                                    editMode={true}
                                    voice={{
                                        "name": "",
                                        "type": null,
                                        "country": null,
                                        "labels": []
                                    }}
                                    onChange={setIsChanged}
                                    onLoading={setLoading}
                                    onVoiceCreated={onVoiceCreated}
                                />
                            </Card.Body>
                            <Card.Body>
                                <div className="d-flex justify-content-end">
                                    <Button key={`btnSave`} className="manage btn-sm ml-2" disabled={!isChanged || loading} variant="primary" onClick={onClickCreate}>
                                        Create
                                        {showLoader()}
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md="7" lg="7" xl="9">
                        <VoiceRelations
                            voiceId={null}
                            voiceName={null}
                            voiceType={null}
                            profiles={[]}
                            medias={[]}
                            urls={[]}
                            crawling={[]}
                            editMode={null}
                        />
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default NewVoice;
